import '../assets/beautrium-css/product.scss';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import the1Logo from '../assets/img/beautrium/the1/logo_blackbg.png'
import moment from 'moment';
import _ from 'lodash';
import styled from "styled-components";
import { keyframes, css } from "styled-components";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faSort } from '@fortawesome/pro-solid-svg-icons';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { frontloadConnect } from 'react-frontload';
import { Link } from 'react-router-dom';
import Rating from 'react-rating';
// import htmlToDraft from 'html-to-draftjs';
// import Slider from 'react-slick'
import { THE1_REDEEM } from '../assets/constant'; //ROLE_ID
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import Lazyload from 'react-lazyload'
import { moneyFormat, getVariantValue, getPromotionName, pixelTrack, pixelAddToWishList, getName } from '../assets/util'; //getFaceShape, getFacetype, getFacetone, getBodytone, getBodyType, getHairtype, 
import { getProductPromise, postCommentMaterial, postRateMaterial, deleteComment } from '../actions/material/index';
import { getProfile } from '../actions/profile/index';
import { addToCart } from '../actions/shopping-cart/index';
import { toggleWishlistItem } from '../actions/profile/index';
import { showAuthenticationPopup } from '../actions/common/index';
import { submitChat } from '../actions/chat';
import { showAllPhotoPopup } from '../actions/allphoto/index';
import { swal, close } from 'react-redux-sweetalert';
import Page from '../components/Page';
import CallToAction from '../components/common/CallToAction';
import SelectBox from '../components/form/SelectBox';
import ProductCard from '../components/product/ProductCard';
import AllPhoto from '../components/product/AllPhoto';
import MultiCarousel from '../components/home/MultiCarousel';
import LoadingInsideDiv from '../components/LoadingInsideDiv';
import ExifOrientationImg from 'react-exif-orientation-img'
import CouponLine from '../components/coupon/CouponLine';
import { DELIVERY_COST } from '../config';
import exclusiveImg from '../assets/img/only-at-B-app.png';

const frontLoad = async props => await props.getProductPromise(props.match.params.mat_id, true, props.location.state ? (props.location.state.ref === "addreview" ? true : false) : false);

const GWPSlide = styled.div`
    animation: ${props => props.styleSlider}
`;

// Product Detail Skeleton Component
const ProductDetailSkeleton = React.memo(() => {
    return (
        <div className="product-detail-skeleton">
            <div className="container">
                {/* Breadcrumb Skeleton */}
                <div className="skeleton-breadcrumb d-none d-xl-flex">
                    <div className="skeleton-breadcrumb-item"></div>
                    <div className="skeleton-breadcrumb-item"></div>
                    <div className="skeleton-breadcrumb-item"></div>
                </div>

                {/* Product Images and Details Row */}
                <div className="product-image-detail-row row">
                    {/* Desktop Images Skeleton */}
                    <span className="images col-xl-1 d-none d-xl-block">
                        <div className="skeleton-thumbnails">
                            {Array.from({ length: 5 }, (_, index) => (
                                <div key={`skeleton-thumbnail-${index}`} className="skeleton-thumbnail"></div>
                            ))}
                        </div>
                    </span>

                    {/* Main Image Skeleton */}
                    <span className="image col-xl-5 d-none d-xl-inline-block">
                        <div className="skeleton-main-image"></div>
                    </span>

                    {/* Mobile Image Carousel Skeleton */}
                    <div className="image-carousel col-12 d-block d-xl-none">
                        <div className="skeleton-main-image"></div>
                    </div>

                    {/* Product Info Skeleton */}
                    <span className="product-detail col-12 col-xl-6">
                        <div className="skeleton-product-info">
                            <div className="skeleton-brand"></div>
                            <div className="skeleton-title"></div>
                            <div className="skeleton-rating"></div>
                            <div className="skeleton-price"></div>

                            {/* Variants Skeleton */}
                            <div className="skeleton-variants">
                                <div className="skeleton-variant"></div>
                                <div className="skeleton-variant"></div>
                                <div className="skeleton-variant"></div>
                            </div>

                            <div className="skeleton-quantity"></div>
                            <div className="skeleton-buttons">
                                <div className="skeleton-button"></div>
                                <div className="skeleton-button"></div>
                            </div>
                        </div>
                    </span>
                </div>
            </div>

            {/* Tabs Skeleton */}
            <div className="container">
                <div className="skeleton-tabs">
                    <div className="skeleton-tab-header">
                        <div className="skeleton-tab"></div>
                        <div className="skeleton-tab"></div>
                        <div className="skeleton-tab"></div>
                        <div className="skeleton-tab"></div>
                    </div>
                    <div className="skeleton-tab-content"></div>
                </div>
            </div>

            {/* Reviews Skeleton */}
            <div className="container-fluid px-0">
                <div className="row bg-white">
                    <div className="col-12">
                        <div className="container">
                            <div className="skeleton-reviews">
                                <div className="skeleton-review-header"></div>
                                {Array.from({ length: 3 }, (_, index) => (
                                    <div key={`skeleton-review-${index}`} className="skeleton-review-item"></div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

ProductDetailSkeleton.displayName = 'ProductDetailSkeleton';

// Optimized ProductImages Component
const ProductImages = React.memo(({
    item,
    imageIndex,
    onImageChange,
    gwp,
    exclusive,
    firstImage
}) => {
    const handleImageChange = React.useCallback((newIndex) => {
        onImageChange(newIndex);
    }, [onImageChange]);

    return (
        <>
            {/* Desktop Images */}
            <span className="images col-xl-1 d-none d-xl-block">
                <ul>
                    <li>
                        <img
                            alt={item.brand_en + " - " + item.mat_name}
                            onMouseEnter={() => handleImageChange("image_1")}
                            src={firstImage}
                        />
                    </li>
                    {item.image_2 && (
                        <li>
                            <img
                                alt={item.brand_en + " - " + item.mat_name}
                                src={item.image_2}
                                onMouseEnter={() => handleImageChange("image_2")}
                            />
                        </li>
                    )}
                    {item.image_3 && (
                        <li>
                            <img
                                alt={item.brand_en + " - " + item.mat_name}
                                src={item.image_3}
                                onMouseEnter={() => handleImageChange("image_3")}
                            />
                        </li>
                    )}
                    {item.image_4 && (
                        <li>
                            <img
                                alt={item.brand_en + " - " + item.mat_name}
                                src={item.image_4}
                                onMouseEnter={() => handleImageChange("image_4")}
                            />
                        </li>
                    )}
                    {item.image_5 && (
                        <li>
                            <img
                                alt={item.brand_en + " - " + item.mat_name}
                                src={item.image_5}
                                onMouseEnter={() => handleImageChange("image_5")}
                            />
                        </li>
                    )}
                </ul>
            </span>

            {/* Desktop Main Image */}
            <span className="image col-xl-5 d-none d-xl-inline-block">
                <div className="image-container">
                    <img alt={`${item.brand_en} ${item.mat_name}`} src={item[imageIndex]} />
                    {gwp && (
                        <div className="gwp-overlay">
                            FREE
                            <div className="gwp-cover">
                                <img src={_.get(gwp, "[0].cover_image.url")} alt={_.get(gwp, "[0].name")} />
                            </div>
                        </div>
                    )}
                    {exclusive && (
                        <div className="" style={{ position: 'absolute', top: 0, right: 10, width: 100, height: 100 }}>
                            <img alt="exclusive" src={exclusiveImg} />
                        </div>
                    )}
                </div>
                <small className="color-gray" style={{ display: "block", paddingTop: '5px', fontSize: "70%" }}>
                    <span style={{ textDecoration: "underline" }}>หมายเหตุ</span> สีที่เห็นอาจแตกต่างจากสีของผลิตภัณฑ์จริงเล็กน้อย เนื่องจากความแตกต่างของแสงเวลาถ่ายรูปผลิตภัณฑ์
                </small>
            </span>

            {/* Mobile Image Carousel */}
            <div className="image-carousel col-12 d-block d-xl-none">
                <MultiCarousel slideToShow={1} responsiveSetting={[{ breakpoint: 576, settings: { slidesToShow: 1 } }]}>
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="image-card">
                            <img alt={`${item.brand_en} ${item.mat_name}`} src={firstImage} />
                            {gwp && (
                                <div className="gwp-overlay">
                                    FREE
                                    <div className="gwp-cover">
                                        <img src={_.get(gwp, "[0].cover_image.url")} alt={_.get(gwp, "[0].name")} />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {item.image_2 && (
                        <div className="d-flex justify-content-center align-items-center">
                            <div className="image-card">
                                <img alt={`${item.brand_en} ${item.mat_name}`} src={item.image_2} />
                            </div>
                        </div>
                    )}
                    {item.image_3 && (
                        <div className="d-flex justify-content-center align-items-center">
                            <div className="image-card">
                                <img alt={`${item.brand_en} ${item.mat_name}`} src={item.image_3} />
                            </div>
                        </div>
                    )}
                    {item.image_4 && (
                        <div className="d-flex justify-content-center align-items-center">
                            <div className="image-card">
                                <img alt={`${item.brand_en} ${item.mat_name}`} src={item.image_4} />
                            </div>
                        </div>
                    )}
                    {item.image_5 && (
                        <div className="d-flex justify-content-center align-items-center">
                            <div className="image-card">
                                <img alt={`${item.brand_en} ${item.mat_name}`} src={item.image_5} />
                            </div>
                        </div>
                    )}
                </MultiCarousel>
                {!!exclusive && (
                    <div className="" style={{ position: 'absolute', top: 0, right: 10, width: 100, height: 100 }}>
                        <img alt="exclusive" src={exclusiveImg} />
                    </div>
                )}
            </div>
        </>
    );
});

ProductImages.displayName = 'ProductImages';

// Optimized ProductInfo Component
const ProductInfo = React.memo(({
    item,
    net_price,
    isMemberPromotion,
    THE1_REDEEM,
    the1Logo,
    onWishlistToggle,
    wishlisted
}) => {
    const handleWishlistToggle = React.useCallback(() => {
        onWishlistToggle(item.mat_var_id, wishlisted);
    }, [onWishlistToggle, item.mat_var_id, wishlisted]);

    return (
        <div className="d-flex flex-column">
            <div className="rate-review order-0">
                <span className="rating mr-3">
                    {item.rating !== 0 ? (
                        <FontAwesomeIcon icon={["fas", "star"]} style={{ color: "#DB1F35" }} />
                    ) : (
                        <FontAwesomeIcon icon={["fal", "star"]} style={{ color: "#ccc" }} />
                    )}
                    <span className="ml-2">{item.rating}</span>
                </span>
                <span>|</span>
                <a href="#reviews-section">
                    <span className="review-count mx-3">
                        {item.comments && item.comments.data ? item.comments.data.length : 0} Reviews
                    </span>
                </a>
                <span>|</span>
                <span
                    className={`ml-3 addtoWishlist ${wishlisted === 1 ? "wishlisted" : ""}`}
                    onClick={handleWishlistToggle}
                >
                    <FontAwesomeIcon icon={["fal", "heart"]} />
                    <FontAwesomeIcon icon={["fas", "heart"]} />
                    <span className="color-black">
                        {wishlisted === 1 ? "Remove From Wishlist" : "Add to Wishlist"}
                    </span>
                </span>
            </div>

            <div className={`price ${(net_price || item.mat_price) < item.mat_label_price ? "has-original" : ""}`}>
                {moneyFormat(net_price ? net_price : item.mat_price, '฿')}
                {isMemberPromotion && <div className="member-price">ราคาสมาชิก</div>}
                {THE1_REDEEM && (
                    <div className={`points mt-2 d-xl-inline-block d-none`}>
                        <span style={{ margin: "0 10px", fontSize: "20px" }}>|</span>
                        <img
                            src={the1Logo}
                            alt="The 1"
                            style={{ width: "auto", height: "20px", margin: "0 5px", verticalAlign: "text-bottom" }}
                        />
                        <span>แลกซื้อใช้ {moneyFormat(Math.ceil(net_price * 8), '', 0)} คะแนน</span>
                    </div>
                )}
            </div>

            {net_price < item.mat_label_price && (
                <div className="original-price">{moneyFormat(item.mat_label_price, '฿')}</div>
            )}

            {THE1_REDEEM && (
                <div className={`points mt-3 d-xl-none d-block`}>
                    <img
                        src={the1Logo}
                        alt="The 1"
                        style={{ width: "auto", height: "20px", margin: "0 5px 0 0" }}
                    />
                    แลกซื้อใช้ <strong>{moneyFormat(Math.ceil(net_price * 8), '', 0)}</strong> คะแนน
                </div>
            )}
        </div>
    );
});

ProductInfo.displayName = 'ProductInfo';

class ProductDetail extends Component {

    constructor(props) {
        super(props);

        this.state = {
            qty: 1,
            currentVariants: this.getCurrentVariants(this.props.material),
            variantIndex: -1,
            imageIndex: 'image_1',
            ratingValue: 0,
            visible: false,
            showImage: false,
            imageUrl: '',
            firstname: '',
            lastname: '',
            comment: '',
            gwpShow: false,
            numReward: 0,
            animationSlideup: { marginTop: 0 },
            styleGWP: null,
            showCoupons: false,
            isContentLoaded: false,
            showSkeleton: !this.props.material // Only show skeleton if no material
        }

        this.changeVariant = this.changeVariant.bind(this);
        this.changeVariantID = this.changeVariantID.bind(this);
        this.addToCart = this.addToCart.bind(this);
        this.refresh = this.refresh.bind(this);
        // this.commentOnSubmit = this.commentOnSubmit.bind(this);
        this.showAllPhoto = this.showAllPhoto.bind(this);
        this.renderPromotionPanel = this.renderPromotionPanel.bind(this);
        this.renderSelect = this.renderSelect.bind(this);
        this.animateGWP = this.animateGWP.bind(this)
        this.onHandleProductComment = this.onHandleProductComment.bind(this)
        this.renderTags = this.renderTags.bind(this);
        this.scrollSlider = this.scrollSlider.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        // Shallow comparison for specific props that matter for rendering
        const propsChanged =
            this.props.material !== nextProps.material ||
            this.props.authenticated !== nextProps.authenticated ||
            this.props.translate !== nextProps.translate ||
            this.props.match.params.mat_id !== nextProps.match.params.mat_id ||
            this.props.match.params.mat_var_id !== nextProps.match.params.mat_var_id ||
            this.props.addWishlistResult !== nextProps.addWishlistResult ||
            this.props.deleteWishlistResult !== nextProps.deleteWishlistResult ||
            this.props.postComment !== nextProps.postComment ||
            this.props.postRate !== nextProps.postRate ||
            this.props.deleteResult !== nextProps.deleteResult;

        // Shallow comparison for state changes
        const stateChanged =
            this.state.qty !== nextState.qty ||
            this.state.variantIndex !== nextState.variantIndex ||
            this.state.imageIndex !== nextState.imageIndex ||
            this.state.visible !== nextState.visible ||
            this.state.showImage !== nextState.showImage ||
            this.state.gwpShow !== nextState.gwpShow ||
            this.state.showCoupons !== nextState.showCoupons ||
            this.state.showSkeleton !== nextState.showSkeleton ||
            this.state.isContentLoaded !== nextState.isContentLoaded;

        return propsChanged || stateChanged;
    }

    componentDidMount() {
        /* eslint-disable */
        $.HSCore.init();

        // initialization of tabs
        $.HSCore.components.HSTabs.init('[role="tablist"]');

        $(window).on('resize', function () {
            setTimeout(function () {
                $.HSCore.components.HSTabs.init('[role="tablist"]');
            }, 200)
        });

        /* eslint-enable */
        if (this.props.material && this.props.material.item_id) {
            pixelTrack('ViewContent', {
                content_ids: this.props.material.item_id,
                content_type: 'product',
                content_category: `${this.props.material.brand_en}-${this.props.material.cat1_id}-${this.props.material.cat2_id}-${this.props.material.cat3_id}`
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.material !== nextProps.material) {
            // Clear cache when material changes
            this.clearCache();

            this.setState({
                currentVariants: this.getCurrentVariants(nextProps.material),
                ratingValue: nextProps.material ? nextProps.material.user_rating : 0
            });

            const mat_var_id = nextProps.match.params.mat_var_id;
            if (mat_var_id) {
                this.changeVariantID(mat_var_id, nextProps.material);
            }
        } else if (this.props.material === nextProps.material) {
            if (this.props.match.params.mat_var_id !== nextProps.match.params.mat_var_id) {
                const mat_var_id = nextProps.match.params.mat_var_id;
                this.changeVariantID(mat_var_id);
            }
        }

        if (this.props.match.params.mat_id !== nextProps.match.params.mat_id) {
            const mat_id = nextProps.match.params.mat_id;
            this.props.getProductPromise(mat_id, false);
        }

        // Handle wishlist and comment updates
        if (this.props.addWishlistResult === null && nextProps.addWishlistResult === true) {
            this.refresh();
        } else if (this.props.deleteWishlistResult === null && nextProps.deleteWishlistResult === true) {
            this.refresh();
        }
        if (this.props.postComment === null && nextProps.postComment === true) {
            this.refresh();
        }
        if (this.props.postRate === null && nextProps.postRate === true) {
            this.refresh();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevProps.material && this.props.material) {
            const mat_var_id = this.props.match.params.mat_var_id;
            this.setState({
                styleGWP: { height: this.gwpContent ? (this.gwpContent.scrollHeight + 10) + "px" : "100px" },
                styleCouponList: { height: this.couponList ? (this.couponList.scrollHeight + 10) + "px" : "100px" }
            });
            if (mat_var_id) {
                this.changeVariantID(mat_var_id);
            }
            pixelTrack('ViewContent', { content_ids: this.props.material.item_id, content_type: 'product' });
            // Only redirect if sizes exist and current mat_id is not in the list
            if (this.props.material.sizes && this.props.material.sizes.length > 0) {
                const allMatIds = _.map(this.props.material.sizes, (size) => size.mat_id);
                if (allMatIds.length > 0 && !allMatIds.includes(this.props.match.params.mat_id)) {
                    this.props.history.push(`/item/${allMatIds[0]}`);
                }
            }

            // Handle content loading state - show content immediately if material is available
            this.setState({ showSkeleton: false, isContentLoaded: true });
        }

        if (prevProps.deleteResult === null && this.props.deleteResult === true) {
            setTimeout(() => this.props.swal({
                title: "Success",
                type: "success",
                onConfirm: this.refresh(),
                customClass: 'bt-dialog-box',
            }), 100);
        }

        // Handle material changes - reset loading state
        if (prevProps.material !== this.props.material) {
            if (this.props.material) {
                // If we have material, show content immediately
                this.setState({ showSkeleton: false, isContentLoaded: true });
            } else {
                // If no material, show skeleton
                this.setState({ showSkeleton: true, isContentLoaded: false });
            }
        }
    }

    componentWillUnmount() {
        clearInterval(this.animateGWPInterval)
        clearTimeout(this.animateGWPTimeout)
    }

    // Memoized method to compute processed item data
    getProcessedItemData(material, variantIndex) {
        if (!material) return null;

        // Create a cache key based on material and variant index
        const cacheKey = `${material.mat_id}_${variantIndex}`;

        // Check if we have cached data
        if (this._itemDataCache && this._itemDataCache[cacheKey]) {
            return this._itemDataCache[cacheKey];
        }

        let item = null;
        const materialTags = material.tags || [];

        if (variantIndex !== -1) {
            item = Object.assign({}, material, material.variants[variantIndex]);
            item.tags = JSON.parse(JSON.stringify(materialTags.concat(material.variants[variantIndex].tags || [])));
        } else {
            // Handle case where feature_variant_id is null or variants array is empty
            if (!material.feature_variant_id || !material.variants || material.variants.length === 0) {
                // If no feature variant or no variants, use the first available variant
                if (material.variants && material.variants.length > 0) {
                    item = Object.assign({}, material, material.variants[0]);
                    item.tags = JSON.parse(JSON.stringify(materialTags.concat(material.variants[0].tags || [])));
                } else {
                    // If no variants at all, use the base material
                    item = Object.assign({}, material);
                    item.tags = JSON.parse(JSON.stringify(materialTags));
                }
            } else {
                const filtered = _.filter(material.variants, (v) => v.mat_var_id === material.feature_variant_id);
                if (filtered.length < 1) {
                    // If feature variant not found, fallback to first variant
                    if (material.variants && material.variants.length > 0) {
                        item = Object.assign({}, material, material.variants[0]);
                        if (material.variants[0]) {
                            item.tags = JSON.parse(JSON.stringify(materialTags.concat(material.variants[0].tags || [])));
                        }
                    } else {
                        // If no variants at all, use the base material
                        item = Object.assign({}, material);
                        item.tags = JSON.parse(JSON.stringify(materialTags));
                    }
                } else {
                    item = Object.assign({}, material, filtered[0]);
                    item.tags = JSON.parse(JSON.stringify(materialTags.concat(filtered[0].tags || [])));
                }
            }
        }

        // Cache the result
        if (!this._itemDataCache) {
            this._itemDataCache = {};
        }
        this._itemDataCache[cacheKey] = item;

        return item;
    }

    // Memoized method to compute variant options
    getVariantOptions(item, type) {
        const cacheKey = `${item.mat_id}_${type}`;

        if (this._variantOptionsCache && this._variantOptionsCache[cacheKey]) {
            return this._variantOptionsCache[cacheKey];
        }

        const options = this.getAllVariantsValue(type, item);

        if (!this._variantOptionsCache) {
            this._variantOptionsCache = {};
        }
        this._variantOptionsCache[cacheKey] = options;

        return options;
    }

    // Clear cache when material changes
    clearCache() {
        this._itemDataCache = {};
        this._variantOptionsCache = {};
    }

    refresh() {
        const { match: { params: { mat_id } } } = this.props;
        this.props.getProductPromise(mat_id, false, true);
    }

    getCurrentVariants(item) {
        if (item === null) {
            return [];
        }
        let currentVariants = [];
        if (item.variant_type_1 !== null) {
            currentVariants[item.variant_type_1] = { name: item.variant_name_1, code: item.variant_code_1 };
        }
        if (item.variant_type_2) {
            currentVariants[item.variant_type_2] = { name: item.variant_name_2, code: item.variant_code_2 };
        }
        if (item.variant_type_3) {
            currentVariants[item.variant_type_3] = { name: item.variant_name_3, code: item.variant_code_3 };
        }
        if (item.variant_type_4) {
            currentVariants[item.variant_type_4] = { name: item.variant_name_4, code: item.variant_code_4 };
        }
        if (item.variant_type_5) {
            currentVariants[item.variant_type_5] = { name: item.variant_name_5, code: item.variant_code_5 };
        }
        return currentVariants;
    }

    getAllVariantsValue(type, items) {
        // Safety check for items and variants
        if (!items || !items.variants || !Array.isArray(items.variants)) {
            return null;
        }

        let ts = _.sortBy(_.uniqBy(_.map(items.variants, (v) => getVariantValue(v, type)), 'name'), 'name');
        if (!ts || ts[0] === null || ts.length <= 1) {
            return null;
        }
        if (type === "Visual Acuity") {
            ts = _.sortBy(ts, (t) => -parseFloat(t.name));
        }
        const newTS = _.filter(ts, (currentItem) => {
            return currentItem && currentItem.name;
        });
        _.map(newTS, (t) => {
            t.label = t.name + ((type !== "Volume" && t.sold_out) ? " - Out of stock." : "");
            // t.label = t.name;// + (t.sold_out ? " - Out of stock.": ""); 
            t.value = t.name;
            delete t.name;
            // delete t.code
        });
        return ts;
    }

    changeVariant(type, value) {
        const { currentVariants } = this.state;
        const { material } = this.props;
        let temp = JSON.parse(JSON.stringify(currentVariants));
        temp[type] = value;
        const index = _.findIndex(material.variants, (o) => {
            let result = true;
            for (var key in temp) {
                let tempBool = false;
                const variantValue = getVariantValue(o, key);
                if (variantValue) {
                    tempBool = variantValue.name === (typeof temp[key].name !== "undefined" ? temp[key].name : temp[key].value);
                } else {
                    tempBool = false;
                }
                result = result && tempBool;
            }
            return result;
        });
        this.setState({ currentVariants: temp, variantIndex: index, imageIndex: 'image_1' });
    }

    changeVariantID(mat_var_id, nextMaterial) {
        const material = nextMaterial || this.props.material;
        if (material) {
            const variants = material.variants;
            const index = _.findIndex(variants, (o) => {
                return parseInt(o.mat_var_id, 10) === parseInt(mat_var_id, 10)
            });
            this.setState({ variantIndex: index });
        }
    }

    addToCart(item) {
        const qty = this.state.qty === '' ? 1 : parseInt(this.state.qty, 10);
        if (qty === '') {
            this.setState({ qty: 1 });
        }

        this.props.addToCart(item, qty);
    }

    onHandleProductComment() {
        const { mat_id, mat_var_id } = this.props.material
        if (!this.props.authenticated) {
            this.props.showAuthenticationPopup(true)
        } else {
            this.props.history.push({ pathname: `/item/${mat_id}/${mat_var_id}/selectshade` })
        }
    }

    alertDeleteComment(mat_no, id) {
        this.props.swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this data!",
            type: "warning",
            onConfirm: () => { this.props.close(); this.props.deleteComment(mat_no, id); },
            // onConfirm: (e) => { e.preventDefault(); this.prop(id)},
            showCancelButton: true,
            closeOnConfirm: true,
            closeOnCancel: true,
            customClass: 'bt-dialog-box',

        })
    }

    renderComments(comments) {
        if (comments.length === 0) {
            return <div style={{ textAlign: "center", marginTop: "20px" }}>เคยใช้ผลิตภัณฑ์ชิ้นนี้หรือเปล่าคะ ถ้าเคยใช้แล้วเป็นยังไงบ้างคะ บอก BEAUTRIUM กับลูกค้าท่านอื่นได้นะคะ</div>
        }
        return _.map(comments, (comment, index) => {
            return (
                <div key={`comment_${index}`} className="row">
                    <div className="col-12 comment">
                        <div className="row">
                            <div className="col-12 col-md-5 profile">
                                <div className="profile-img-holder">
                                    {comment.img_profile
                                        ? <img alt={comment.first_name + " " + comment.last_name} src={comment.img_profile} className="profile-img" />
                                        : <img alt={"anonymous"} src="https://cdn.thebeautrium.com/web-image/dummy.jpg" className="profile-img" />
                                    }
                                </div>
                                <div className="profile-owner-container">
                                    <div className="profile-owner">
                                        <div className="profile-name">{getName({ first_name: comment.first_name, last_name: comment.last_name, alias: comment.alias }, true)}</div>
                                        <div className="comment-date">{moment(comment.created_date).format('DD MMMM YYYY')}</div>
                                        <div className="comment-rating d-none d-md-block">
                                            <span className="rating">
                                                <Rating
                                                    emptySymbol={<FontAwesomeIcon icon={["fal", "star"]} style={{ color: "#ccc" }} />}
                                                    fullSymbol={<FontAwesomeIcon icon={["fas", "star"]} style={{ color: "#DB1F35" }} />}
                                                    readonly={true}
                                                    initialRating={parseFloat(comment.rating)}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="comment-rating d-block d-md-none">
                                        <span className="rating">
                                            <Rating
                                                emptySymbol={<FontAwesomeIcon icon={["fal", "star"]} style={{ color: "#ccc" }} />}
                                                fullSymbol={<FontAwesomeIcon icon={["fas", "star"]} style={{ color: "#DB1F35" }} />}
                                                readonly={true}
                                                initialRating={parseFloat(comment.rating)}
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-7 d-flex flex-column">
                                <div className="comment-text order-1 order-md-2">{comment.comment}</div>
                                <div className="order-2 order-md-3">
                                    {comment.img_url1 ?
                                        <div key={"ph_" + index + "_1"} className="comment-image-holder">
                                            <div className="w-100 padding-top-100 position-relative comment-image-container" onClick={() => this.setState({ imageUrl: comment.img_url1, showImage: true })}>
                                                <ExifOrientationImg src={comment.img_url1} alt={comment.first_name} className="comment-image" />
                                            </div>
                                        </div>
                                        :
                                        null
                                    }
                                    {comment.img_url2 ?
                                        <div key={"ph_" + index + "_2"} className="comment-image-holder">
                                            <div className="w-100 padding-top-100 position-relative comment-image-container" onClick={() => this.setState({ imageUrl: comment.img_url2, showImage: true })}>
                                                <ExifOrientationImg src={comment.img_url2} alt={comment.first_name} className="comment-image" />
                                            </div>
                                        </div>
                                        :
                                        null
                                    }
                                </div>
                                {comment.variant_name_2 ? <div className="comment-variant order-3 order-md-1">ตัวเลือกสินค้า: {comment.variant_name_2}</div> : null}
                            </div>
                        </div>

                    </div>

                </div>);
        })
    }

    renderPhotoReview(comments) {
        const { material } = this.props
        const allImages = _.reduce(comments, (result, comment) => {
            const temp = []
            if (comment.img_url1 && comment.img_url1.trim() !== "") {
                temp.push({
                    img_url: comment.img_url1,
                    firstname: comment.first_name,
                    lastname: comment.last_name,
                    comment: comment.comment
                })
            }
            if (comment.img_url2 && comment.img_url2.trim() !== "") {
                temp.push({
                    img_url: comment.img_url2,
                    firstname: comment.first_name,
                    lastname: comment.last_name,
                    comment: comment.comment
                })
            }
            return result.concat(temp)
        }, [])
        return _.map(allImages.slice(0, 4), (image, index) => {
            return <div key={"review_photo_" + index} className={`col-3 col-md-2`}>
                <div className="photo-container">
                    <div className="photo" onClick={() => {
                        if (index === 3) {
                            this.showAllPhoto(true)
                        } else {
                            this.setState({ imageUrl: image.img_url, firstname: image.firstname, lastname: image.lastname, comment: image.comment, showImage: true });
                        }
                    }}>
                        <img src={image.img_url} alt={material.brand_en + " " + material.mat_name} />
                        {(index === 3 || index === 5)
                            ? <div className={`more justify-content-center align-items-center d-flex`}><FontAwesomeIcon icon={faPlus} /></div>
                            : null}
                    </div>
                </div>
            </div>
        })
        // const result = _.map(photos, (photo, index) => {
        //     let result = [];
        //     if (photo.img_url1) {
        //         if (photo.img_url1.trim() !== "") {
        //             result.push(
        //                 <div key={index + "_1"} className="col-12">
        //                     <div className="w-100 padding-top-100" style={{ background: `url(${photo.img_url1})`, backgroundSize: "cover", backgroundPosition: "center center", cursor: "pointer" }} onClick={() => this.setState({ imageUrl: photo.img_url1, firstname: photo.first_name, lastname: photo.last_name, comment: photo.comment, showImage: true })}> </div>
        //                 </div>
        //             )
        //         }
        //     }
        //     if (photo.img_url2) {
        //         if (photo.img_url2.trim() !== "") {
        //             result.push(
        //                 <div key={index + "_2"} className="col-12">
        //                     <div className="w-100 padding-top-100" style={{ background: `url(${photo.img_url2})`, backgroundSize: "cover", backgroundPosition: "center center", cursor: "pointer" }} onClick={() => this.setState({ imageUrl: photo.img_url2, firstname: photo.first_name, lastname: photo.last_name, comment: photo.comment, showImage: true })}></div>
        //                 </div>
        //             )
        //         }
        //     }
        //     return result;
        // })
        // return(
        //     <Slider {...settings}>
        //         {result}
        //     </Slider>
        // )
    }

    wishlistToggle(mat_var_id, wishlisted = 0) {
        const { authenticated, showAuthenticationPopup } = this.props;
        if (authenticated) {
            this.props.toggleWishlistItem(mat_var_id, wishlisted === 0);
            if (!wishlisted) {
                pixelAddToWishList(this.props.material)
            }
        } else {
            showAuthenticationPopup(true);
        }
    }

    renderPromotionProductCard(products, free = false) {
        return _.map(products, (p, index) => {
            return (
                <div
                    key={index}
                    style={{
                        display: 'inline-block',
                        minWidth: '200px',
                        width: '200px',
                        marginRight: '15px',
                        flexShrink: 0
                    }}
                >
                    <ProductCard item={p} showPromotion={false} free={free} lazyLoad={false} />
                </div>
            );
        });
    }

    renderSelect(limit) {
        return _.times(limit, (n) => {
            if (n >= 0) {
                return <option key={n + 1}>{n + 1}</option>
            }
            else {
                return null;
            }
        });
    }

    renderPromotionPanel(item, promotion, discount_type, isMemberPro = false) {
        if (promotion) {
            // console.log(promotion, item, discount_type);
            let header = null, content = null, hasMore = false, relateIds = [];
            if (promotion.p001 !== 0) {
                header = `โปรโมชั่น ซื้อ ${discount_type.min} ชิ้น${discount_type.min !== discount_type.max ? "ขึ้นไป" : ""}ราคา ${moneyFormat(discount_type.data[discount_type.min][0].sale_amt, '฿')}`
                content = this.renderPromotionProductCard(discount_type.data[discount_type.min])
            } else if (promotion.p002 !== 0) {
                header = `โปรโมชั่น ซื้อชิ้นที่ ${item.pro_002.sale_qty} ลด ${item.pro_002.disc}%`
                content = this.renderPromotionProductCard(item.pro_002.group_discount)
            } else if (promotion.p004 !== 0 && item.pro_004) {
                header = `โปรโมชั่น ${promotion.sale_qty ? promotion.sale_qty : 1} แถม ${promotion.free_qty ? promotion.free_qty : 1}`
                content = this.renderPromotionProductCard(item.pro_004 ? item.pro_004.free : [], true)
            } else if (promotion.p005 !== 0) {
                if (item.pro_005.line_spec === 1) {
                    header = `โปรโมชั่นซื้อ${item.pro_005.sale_qty === 2 ? "คู่" : " " + item.pro_005.sale_qty + " ชิ้น"}ในราคาพิเศษ`;
                } else {
                    header = `โปรโมชั่นซื้อ${item.pro_005.sale_qty === 2 ? "คู่" : " " + item.pro_005.sale_qty + " ชิ้น"}ในราคา ${moneyFormat(item.pro_005.new_price, '฿')}`;
                }
                content = this.renderPromotionProductCard(item.pro_005.sale)
                hasMore = item.pro_005.has_more;
                relateIds = item.pro_005.relate_items;
            } else if (promotion.p006 !== 0) {
                header = `ซื้อพร้อมกับสินค้าเหล่านี้ครบ ${item.pro_006.sale_qty} ชิ้นลด ${promotion.discount_percent}%`
                content = (item.pro_006.sale && item.pro_006.sale.length > 0) ? this.renderPromotionProductCard(item.pro_006.sale) : null;
            }
            if (!header) {
                return null
            }
            return (
                <div className="container promotion">
                    <div className="header">
                        {header} {isMemberPro && <div className="member-price">ราคาสมาชิก</div>}
                    </div>
                    {content
                        ? <div className="product-slider" style={{ display: 'flex', flexDirection: 'row', width: '100%', margin: '20px 0', position: 'relative' }}>
                            {/* Debug info */}
                            {console.log('Rendering product slider with content:', content)}
                            {console.log('Content length:', content ? content.length : 0)}

                            <div
                                className="slider-container"
                                ref={(el) => {
                                    this.sliderContainer = el;
                                    // Debug: log when ref is set
                                    if (el) {
                                        console.log('Slider container ref set:', el);
                                        console.log('Container width:', el.clientWidth);
                                        console.log('Container scrollWidth:', el.scrollWidth);
                                    }
                                }}
                                style={{
                                    margin: 0,
                                    padding: 0,
                                    paddingBottom: '20px',
                                    overflowX: 'auto',
                                    width: '100%',
                                    display: 'flex',
                                    position: 'relative',
                                    border: '1px solid #eee' // Debug border
                                }}
                            >
                                {content}
                            </div>
                            {/* Navigation arrows for better UX */}
                            <button
                                className="slider-nav slider-nav--prev"
                                onClick={() => this.scrollSlider('left')}
                                aria-label="Scroll left"
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '-20px',
                                    transform: 'translateY(-50%)',
                                    width: '40px',
                                    height: '40px',
                                    background: 'rgba(255, 255, 255, 0.9)',
                                    border: '1px solid #ddd',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '20px',
                                    color: '#666',
                                    cursor: 'pointer',
                                    zIndex: 10,
                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                                }}
                            >
                                ‹
                            </button>
                            <button
                                className="slider-nav slider-nav--next"
                                onClick={() => this.scrollSlider('right')}
                                aria-label="Scroll right"
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    right: '-20px',
                                    transform: 'translateY(-50%)',
                                    width: '40px',
                                    height: '40px',
                                    background: 'rgba(255, 255, 255, 0.9)',
                                    border: '1px solid #ddd',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '20px',
                                    color: '#666',
                                    cursor: 'pointer',
                                    zIndex: 10,
                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                                }}
                            >
                                ›
                            </button>
                        </div>
                        : <div className="d-flex" style={{ justifyContent: "center", alignItems: "center" }}>
                            <h4 style={{ fontSize: 14, paddingTop: 15, paddingBottom: 15, fontWeight: 300, color: '#929497' }}>ขออภัยค่ะ สินค้าที่ร่วมรายการหมดแล้วค่ะ</h4>
                        </div>}
                    {
                        hasMore
                            ? <div className="d-flex mt-2" style={{ justifyContent: "center", alignItems: "center" }}>
                                <button className="btn btn-outline-primary" onClick={() => this.props.history.push("/shop?products=" + relateIds.join(','))}>ดูสินค้าที่เกี่ยวข้องทั้งหมด</button>
                            </div>
                            : null
                    }
                </div>
            )

        } else {
            return null
        }
    }

    showAllPhoto(visible) {
        this.setState({
            visible: visible
        })
    }

    scrollSlider(direction) {
        console.log('scrollSlider called with direction:', direction);
        console.log('sliderContainer ref:', this.sliderContainer);

        if (this.sliderContainer) {
            const container = this.sliderContainer;
            const scrollAmount = container.clientWidth * 0.8; // Scroll 80% of container width

            console.log('Container dimensions:', {
                clientWidth: container.clientWidth,
                scrollWidth: container.scrollWidth,
                scrollLeft: container.scrollLeft,
                scrollAmount: scrollAmount
            });

            if (direction === 'left') {
                container.scrollBy({
                    left: -scrollAmount,
                    behavior: 'smooth'
                });
            } else {
                container.scrollBy({
                    left: scrollAmount,
                    behavior: 'smooth'
                });
            }

            // Log after scroll
            setTimeout(() => {
                console.log('After scroll - scrollLeft:', container.scrollLeft);
            }, 100);
        } else {
            console.warn('sliderContainer ref is not set');
        }
    }

    renderSizes(sizes, current_id) {
        const numberSchema = /\d+(\.\d+)?/
        const sortedSizes = _.sortBy(sizes, [function (s) {
            return s.volume.match(numberSchema) ? +(s.volume.match(numberSchema)[0]) : 0;
        }])
        return _.map(sortedSizes, (size) => {
            return <Link key={size.mat_id + "_" + size.volume} to={`/item/${size.mat_id}`} className={`mat-size ${size.mat_id === current_id ? "active" : ""}`}><span>{size.volume}</span></Link>
        })
    }

    renderGwp(gwps) {
        let result = []
        _.each(gwps, (gwp, i) => {
            _.each(gwp.rewards, (r, ri) => {
                result.push(
                    <div key={"gwp_reward_" + i + "_" + ri} className="col-xl-6 col-12 gwp-card">
                        <div className="row">
                            <div className="col-4 image"><img src={r.image_1} alt={gwp.name} className="w-100" /></div>
                            <div className="col-8 text">• ฟรี! {r.brand_en} {r.mat_name} {r.volume ? r.volume : ""}<small>{gwp.name}</small></div>
                        </div>
                    </div>
                )
            })
        })
        return result
        // return _.map(rewards, (r, i) => {
        //     return (
        //         <div key={"gwp_reward_" + i} className="col-xl-6 col-12 gwp-card">
        //             <div className="row">
        //                 <div className="col-4 image"><img src={r.image_1} alt={gwp.name} className="w-100" /></div>
        //                 <div className="col-8 text">• ฟรี! {r.brand_en} {r.mat_name}</div>
        //             </div>
        //         </div>
        //     )
        // })
    }

    renderSlides(gwps) {
        const result = []
        _.each(gwps, (g, i) => {
            _.each(g.rewards, (r, ri) => {
                result.push(
                    <div key={"gwp_slide_reward_" + i + "_" + ri} className="gwp-slide">
                        <img src={r.image_1} alt={g.name} />
                        <div><div style={{ fontSize: 14 }}>• ฟรี! {r.brand_en} {r.mat_name} {r.volume ? r.volume : ""}</div><small>{g.name}</small></div>
                    </div>
                )
            })
        })
        return result
        // return _.map(rewards, (r, i) => {
        //     return (
        //         <div key={"gwp_slide_reward_" + i} className="gwp-slide">
        //             <img src={r.image_1} alt={gwp.name} />
        //             <div>• ฟรี! {r.brand_en} {r.mat_name}</div>
        //         </div>
        //     )
        // })
    }

    animateGWP() {
        const numRewards = this.props.material ? this.props.material.gwp[0].rewards.length : 0
        if (numRewards === 0) {
            clearInterval(this.animateGWPInterval)
            return;
        }
        let nextReward = this.state.numReward + 1;
        if (nextReward > numRewards) {
            nextReward = 0
        }
        this.setState(prev => { return { animationSlideup: { marginTop: "-" + (nextReward * 95) + "px" }, numReward: nextReward } })
    }

    generateKeyframes(gwp) {
        const waitingTime = 1.5
        const motionTime = 0.5
        const totalRewards = _.reduce(gwp, (sum, g) => { return sum + g.rewards.length }, 0)
        let tempRewards = []
        _.each(gwp, (g, i) => {
            tempRewards.push(g.rewards)
        })
        const rewards = _.flatMapDeep(tempRewards)
        let totalSec = (totalRewards + 1) * (waitingTime + motionTime)
        let preWaitingPercent = (100 / totalSec * (motionTime / 2));
        let waitingPercent = (100 / totalSec * waitingTime);
        let animatePercent = (100 / totalSec * motionTime);
        let marginOffset = -95
        let keyframesString = `
        0% {margin-top: ${(-marginOffset) / 2}px;} 
        ${preWaitingPercent}% {margin-top: 0px;} 
        ${preWaitingPercent + waitingPercent}% {margin-top: 0px;}
        `
        let lastPercent = waitingPercent + preWaitingPercent;
        _.each(rewards, (r, i) => {
            lastPercent += animatePercent
            keyframesString += `${lastPercent}% {margin-top: ${marginOffset * (i + 1)}px}`
            lastPercent += waitingPercent
            keyframesString += `${lastPercent}% {margin-top: ${marginOffset * (i + 1)}px}`
            if (i === totalRewards - 1) {
                keyframesString += `100% {margin-top: ${marginOffset * (i + 1) + (marginOffset / 2)}px}`
            }
        })
        return keyframes`${keyframesString}`
    }

    renderCouponsHeader(coupons) {
        return _.map(coupons, (coupon, index) => {
            return (
                <li key={"coupon_header_" + index}>
                    <div className="coupon-header">
                        {coupon.type === "transport"
                            ? <span className="coupon-benefit">{(coupon.discount_amt >= DELIVERY_COST || coupon.discount_percent === 100) ? 'ส่งฟรี' : 'ส่วนลดค่าจัดส่ง ' + (coupon.discount_percent ? coupon.discount_percent + ' %' : coupon.discount_amt + '.-')}</span>
                            : <span className="coupon-benefit">ส่วนลด {coupon.discount_amt ? moneyFormat(coupon.discount_amt, '฿', 0) : coupon.discount_percent + "%"}</span>}
                        <span className="collect-button">เก็บ</span>
                    </div>
                </li>)
        })
    }

    renderFullCoupons(coupons) {
        return _.map(coupons, (coupon, index) => {
            return (
                <CouponLine key={"coupon_detail_" + index} coupon={coupon} />
            )
        })
    }

    renderTags(tags) {
        const { currentLanguage } = this.props;
        return (
            _.map(tags, (tag, index) => {
                if (tag.tag_type_id !== 1) {
                    return (
                        <div key={"tag_group_" + index} className="tag-group">
                            <h3 className="tag-head">{currentLanguage.code === "th" ? tag.tag_type_th : tag.tag_type_en} :</h3>
                            <div className="tag-values">{Array.isArray(tag.tags) ? _.map(tag.tags, (t, i) => {
                                return <span key={"tag_value_" + index + "_" + i} className="tag-value">{t.text}</span>
                            }) : <span key={"tag_value_" + index + "_0"} className="tag-value">{tag.tags}</span>}</div>
                        </div>
                    )
                }
                return null;
            })
        );
    }

    render() {
        const { material, translate, submitChat } = this.props;
        const { variantIndex, imageIndex, showCoupons, styleGWP, styleCouponList, showSkeleton } = this.state;

        // Show skeleton while loading (only if no material)
        if (showSkeleton && !material) {
            return (
                <Page id="product" style={{ minHeight: '100vh' }}>
                    <ProductDetailSkeleton />
                </Page>
            );
        }

        // Early return if no material
        if (!material) {
            return null;
        }

        if (material.code === "PRODUCT_NOT_FOUND") {
            this.props.history.push('/404');
            return null;
        }

        // Use memoized data processing
        const item = this.getProcessedItemData(material, variantIndex);
        if (!item) {
            return null;
        }

        // Pre-calculate expensive values
        const { discount_type, promotion } = item;
        const soldOut = item.sold_out !== null && typeof item.sold_out !== "undefined" ? (item.sold_out || item.limit === 0) : true;
        const net_price = item.net_price ? item.net_price : item.mat_price;
        const firstImage = item.image_1 ? item.image_1 : "https://cdn.thebeautrium.com/image-product/no_image.jpg";
        const sizes = item.sizes;
        const commentWithoutOrder = item.userCommentWithoutOrder ? _.filter(item.userCommentWithoutOrder, (c) => c.mat_var_id === material.mat_var_id) : [];
        const productToChat = _.pick(item, ['mat_var_id', 'mat_id', 'mat_name', 'image_cart', 'item_id', 'brand_en', 'variant_type_1', 'variant_name_1', 'variant_type_2', 'variant_name_2', 'variant_type_3', 'variant_name_3', 'variant_type_4', 'variant_name_4', 'variant_type_5', 'variant_name_5', 'mat_price', 'net_price', 'promotion', 'pro_004.sale_qty', 'pro_004.free_qty']);
        const isFree = item.free;
        const gwp = (item.gwp && item.gwp.length > 0) ? _.sortBy(item.gwp, g => g.priority) : null;
        const exclusive = item.exclusive;

        // Memoize expensive calculations
        const slideUp = gwp ? this.generateKeyframes(gwp) : "";
        const totalRewards = gwp ? _.reduce(gwp, (sum, g) => { return sum + g.rewards.length }, 0) : 0;
        const styleSlider = gwp ? css`${slideUp} ${(totalRewards + 1) * 2}s linear infinite` : "";

        // SEO and title calculations
        let seoTitle = item.seo_title ? item.seo_title : (item.brand_en + " " + item.mat_name);
        const titlePro = getPromotionName(item, { percent: true });
        const isMemberPromotion = item.promotion ? (item.promotion.member_value ? true : false) : false;
        seoTitle = seoTitle + (titlePro ? (" | " + titlePro) : "");
        let tempKeywordsTH = item.mat_name_th ? item.mat_name_th.split(" ") : "";
        const keywordsTH = tempKeywordsTH !== "" ? tempKeywordsTH.slice(0, item.mat_name.split(" ").length).join(" ") + "," + tempKeywordsTH.slice(item.mat_name.split(" ").length).join(",") : "";

        return (
            <Page
                id="product"
                product={item}
                title={seoTitle}
                noTailTitle={item.seo_title ? true : false}
                keyword={`${item.brand_en}, ${item.brand_th}, ${item.mat_name}, ${keywordsTH}`}
                noDefaultKeywords={true}
                tags={[item.mat_name, item.brand_en, 'BEAUTRIUM']}
                image={item.image_1}
                imageType={firstImage.substr(firstImage.lastIndexOf('.') + 1)}
                imageWidth={500}
                imageHeight={500}
            >
                <div className="product-content">
                    <div className="container">
                        {/* Breadcrumb */}
                        <div className="breadcrumb-container d-none d-xl-flex">
                            <ul className="bt-breadcrumb">
                                <li><Link to="/">Home</Link><FontAwesomeIcon icon={["fal", "chevron-right"]} className="ml-2" /></li>
                                <li><Link to={`/shop/${item.brand_en}`}>{item.brand_en}</Link><FontAwesomeIcon icon={["fal", "chevron-right"]} className="ml-2" /></li>
                                <li>{item.mat_name}</li>
                            </ul>
                        </div>

                        {/* Product Images and Details Row */}
                        <div className="product-image-detail-row row">
                            <ProductImages
                                item={item}
                                imageIndex={imageIndex}
                                onImageChange={(newIndex) => this.setState({ imageIndex: newIndex })}
                                gwp={gwp}
                                exclusive={exclusive}
                                firstImage={firstImage}
                            />

                            <span className="product-detail col-12 col-xl-6">
                                {/* GWP Section */}
                                {gwp && (
                                    <div className="gwp-section">
                                        <div className={`gwp-header`} onClick={() => this.setState((prev) => { return { gwpShow: !prev.gwpShow, styleGWP: { height: this.gwpContent ? (this.gwpContent.scrollHeight + 10) + "px" : "100px" } } })}>
                                            <div className="gwp-slider">
                                                <GWPSlide className="gwp-slide" styleSlider={styleSlider}>
                                                    <img src={_.get(gwp, "[0].cover_image.url")} alt={"ของแถมเมื่อซื้อสินค้า " + item.brand_en + " - " + item.mat_name} />
                                                    <div>
                                                        <div>ฟรี ของแถม!</div>
                                                        <div>{totalRewards} รายการ</div>
                                                    </div>
                                                </GWPSlide>
                                                {this.renderSlides(gwp)}
                                            </div>
                                            <div className={`chevron-down ${this.state.gwpShow ? "" : "flip-y"}`}>
                                                <FontAwesomeIcon icon={["fal", "chevron-down"]} />
                                            </div>
                                        </div>
                                        <div className={`gwp-content row ${this.state.gwpShow ? "" : "hidden"}`} style={styleGWP} ref={(e) => this.gwpContent = e}>
                                            {this.renderGwp(gwp)}
                                        </div>
                                    </div>
                                )}

                                {/* Product Basic Info */}
                                <div className="brand">
                                    <Link to={`/shop/${item.brand_en}`}>{item.brand_en}</Link>
                                </div>
                                <h1 className="name">{item.mat_name}</h1>

                                {/* Product Info Component */}
                                <ProductInfo
                                    item={item}
                                    net_price={net_price}
                                    isMemberPromotion={isMemberPromotion}
                                    THE1_REDEEM={THE1_REDEEM}
                                    the1Logo={the1Logo}
                                    onWishlistToggle={this.wishlistToggle}
                                    wishlisted={item.wishlisted}
                                />

                                {/* Coupons Section */}
                                {(item.coupons && item.coupons.length > 0) && (
                                    <div className="coupons">
                                        <div className="header-section row align-items-center" onClick={() => this.setState(prev => { return { showCoupons: !prev.showCoupons } })}>
                                            <div className="col-2" style={{ fontWeight: "500" }}>คูปอง</div>
                                            <div className="col-10"><ul>{this.renderCouponsHeader(item.coupons)}</ul></div>
                                        </div>
                                        <div ref={e => this.couponList = e} className={`coupons-list ${showCoupons ? "" : "hidden"}`} style={styleCouponList}>
                                            {this.renderFullCoupons(item.coupons)}
                                        </div>
                                    </div>
                                )}

                                {/* Sizes Section */}
                                {(sizes && sizes.length > 0 && sizes[0].volume) && (
                                    <div className="sizes row">
                                        <div className="col-2 title">ขนาด:</div>
                                        <div className="col-10 sizes-list">
                                            {this.renderSizes(sizes, item.mat_id)}
                                        </div>
                                    </div>
                                )}

                                {/* Variants Section */}
                                {(this.getVariantOptions(item, "Colour") || this.getVariantOptions(item, "Style") || this.getVariantOptions(item, "Visual Acuity") || this.getVariantOptions(item, "Scent")) && (
                                    <div className="variants">
                                        {this.getVariantOptions(item, "Colour") && (
                                            <div className="variant-colours-select row">
                                                <div className="col-2 title">สี: </div>
                                                <div className="col-10 col-md-6">
                                                    <SelectBox
                                                        key={"variantColor_" + item.mat_no}
                                                        options={this.getVariantOptions(item, "Colour")}
                                                        selected={(() => {
                                                            const t = getVariantValue(item, "Colour");
                                                            return t ? { label: t.name, value: t.name, code: t.code } : null;
                                                        })()}
                                                        onChange={(v) => { this.changeVariant("Colour", v) }}
                                                        styles={{
                                                            control: (provided, state) => ({
                                                                ...provided,
                                                                border: "1px solid #231f20",
                                                                boxShadow: 'none',
                                                            }),
                                                            indicatorSeparator: () => ({
                                                                display: 'none'
                                                            }),
                                                            option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                                                                const color = data.code;
                                                                let colorObj = {};
                                                                if (color && color.charAt(0) === "#") {
                                                                    colorObj = {
                                                                        alignItems: 'center',
                                                                        display: 'flex',
                                                                        ':before': {
                                                                            backgroundColor: color,
                                                                            borderRadius: 3,
                                                                            content: '" "',
                                                                            display: 'block',
                                                                            marginRight: 8,
                                                                            height: 15,
                                                                            width: 15,
                                                                        }
                                                                    }
                                                                }
                                                                return {
                                                                    ...styles, ...colorObj
                                                                }
                                                            },
                                                            singleValue: (styles, { data }) => {
                                                                const color = data.code;
                                                                let colorObj = {};
                                                                if (color && color.charAt(0) === "#") {
                                                                    colorObj = {
                                                                        alignItems: 'center',
                                                                        display: 'flex',
                                                                        ':before': {
                                                                            backgroundColor: color,
                                                                            borderRadius: 3,
                                                                            content: '" "',
                                                                            display: 'block',
                                                                            marginRight: 8,
                                                                            height: 15,
                                                                            width: 15,
                                                                        }
                                                                    }
                                                                }
                                                                return {
                                                                    ...styles, ...colorObj
                                                                }
                                                            },
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {this.getVariantOptions(item, "Scent") && (
                                            <div className="variant-colours-select row">
                                                <div className="col-2 title">กลิ่น: </div>
                                                <div className="col-10 col-md-6">
                                                    <SelectBox
                                                        key={"variantScent_" + item.mat_no}
                                                        options={this.getVariantOptions(item, "Scent")}
                                                        selected={(() => {
                                                            const t = getVariantValue(item, "Scent");
                                                            return t ? { label: t.name, value: t.name } : null;
                                                        })()}
                                                        onChange={(v) => { this.changeVariant("Scent", v) }}
                                                        styles={{
                                                            control: (provided, state) => ({
                                                                ...provided,
                                                                border: "1px solid #231f20",
                                                                boxShadow: 'none',
                                                            }),
                                                            indicatorSeparator: () => ({
                                                                display: 'none'
                                                            })
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {this.getVariantOptions(item, "Style") && (
                                            <div className="variant-colours-select row">
                                                <div className="col-2 title">รูปแบบ (สไตล์): </div>
                                                <div className="col-10 col-md-6">
                                                    <SelectBox
                                                        key={"variantStyle_" + item.mat_no}
                                                        options={this.getVariantOptions(item, "Style")}
                                                        selected={(() => {
                                                            const t = getVariantValue(item, "Style");
                                                            return t ? { label: t.name, value: t.name } : null;
                                                        })()}
                                                        onChange={(v) => { this.changeVariant("Style", v) }}
                                                        styles={{
                                                            control: (provided, state) => ({
                                                                ...provided,
                                                                border: "1px solid #231f20",
                                                                boxShadow: 'none',
                                                            }),
                                                            indicatorSeparator: () => ({
                                                                display: 'none'
                                                            })
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {this.getVariantOptions(item, "Visual Acuity") && (
                                            <div className="variant-colours-select row">
                                                <div className="col-2 title">ค่าสายตา: </div>
                                                <div className="col-10 col-md-6">
                                                    <SelectBox
                                                        key={"variantVA_" + item.mat_no}
                                                        options={this.getVariantOptions(item, "Visual Acuity")}
                                                        selected={(() => {
                                                            const t = getVariantValue(item, "Visual Acuity");
                                                            return t ? { label: t.name, value: t.name } : null;
                                                        })()}
                                                        onChange={(v) => { this.changeVariant("Visual Acuity", v) }}
                                                        styles={{
                                                            control: (provided, state) => ({
                                                                ...provided,
                                                                border: "1px solid #231f20",
                                                                boxShadow: 'none',
                                                            }),
                                                            indicatorSeparator: () => ({
                                                                display: 'none'
                                                            })
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                                <div className="quantity row align-items-center">
                                    <div className="col-2 title">จำนวน: </div>
                                    <div className="col-2 d-flex flex-row align-items-center bt-quantity">
                                        <select ref={e => this.select = e} className="" value={this.state.qty} onChange={(e) => { this.setState({ qty: e.target.value }) }}>
                                            {this.renderSelect(Math.min(item.limit, item.quantity))}
                                        </select>
                                        <FontAwesomeIcon className="d-md-none d-block" icon={faSort} onClick={() => this.select.click()} />
                                    </div>
                                    {item.pro_004 && <div className="quantity pt-1 mt-0 ml-3">
                                        <small>โปรโมชั่นสินค้าแถม โปรดหยิบเข้ารถเข็นตรงตามจำนวนพร้อมสินค้าแถมค่ะ</small>
                                    </div>}
                                </div>

                                {item.special_text
                                    ? <div className="row mt-3">
                                        <div className="col-12" dangerouslySetInnerHTML={{ __html: item.special_text }}></div>
                                    </div>
                                    : null}
                                <div className="command row">
                                    {isFree ? <div className="col-6 px-1"><button className="btn btn-red w-100" disabled>สินค้าของแถม</button></div> : null}
                                    {!isFree ? <div className="col-6 px-1"><button className="btn btn-red w-100" onClick={() => { this.addToCart(item) }} disabled={soldOut}><FontAwesomeIcon icon={["fas", "shopping-cart"]} /> {!soldOut ? translate(`ADD_TO_CART`) : translate(`SOLD_OUT`)}</button></div> : null}
                                    {!isFree ? <div className="col-6 px-1"><button className="btn btn-white w-100" onClick={() => { submitChat("product", productToChat) }}><FontAwesomeIcon icon={["fal", "comments"]} /> สอบถามสินค้า</button></div> : null}
                                </div>
                                <div className="other order-last">
                                    {/* <span>BEAUTRIUM points earned with this product: <span className="color-red">30 POINTS</span></span> */}
                                </div>
                            </span>
                        </div>
                    </div>

                    {this.renderPromotionPanel(item, promotion, discount_type, isMemberPromotion)}

                    <div className="container-fluid px-0" style={{ margin: "30px 0" }}>
                        <CallToAction />
                    </div>
                    <div id="post-cta" className="container">
                        <div id="post-cta-anchor" className="anchor" />
                        <div className="description-tabs">
                            <ul className="nav" role="tablist" data-target="nav-1-2-default-hor-left-underline" data-btn-classes="btn btn-md btn-block rounded-0 u-btn-outline-primary g-mb-20">
                                <li className="nav-item">
                                    <a className="nav-link active" data-toggle="tab" href="#nav-1-2-default-hor-left-underline--1" role="tab"><h2>รายละเอียด</h2></a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-toggle="tab" href="#nav-1-2-default-hor-left-underline--2" role="tab"><h2>คุณสมบัติ</h2></a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-toggle="tab" href="#nav-1-2-default-hor-left-underline--3" role="tab"><h2>วิธีการใช้</h2></a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-toggle="tab" href="#nav-1-2-default-hor-left-underline--4" role="tab"><h2>ส่วนประกอบ</h2></a>
                                </li>
                            </ul>

                            <div id="nav-1-2-default-hor-left-underline" className="tab-content">
                                <EditableDetail id={item.item_id + "_mat_desc"} index={1} name="mat_desc" html={item.mat_desc || item.wrapper_mat_desc} mat_var_id={material.mat_var_id} authenticated={this.props.authenticated} />
                                <EditableDetail id={item.item_id + "_mat_benefits"} index={2} name="mat_benefits" html={item.mat_benefits || item.wrapper_mat_benefits} mat_var_id={material.mat_var_id} authenticated={this.props.authenticated} />
                                <EditableDetail id={item.item_id + "_mat_howto"} index={3} name="mat_howto" html={item.mat_howto || item.wrapper_mat_howto} mat_var_id={material.mat_var_id} authenticated={this.props.authenticated} />
                                <EditableDetail id={item.item_id + "_mat_ingredients"} index={4} name="mat_ingredients" html={item.mat_ingredients || item.wrapper_mat_ingredients} mat_var_id={material.mat_var_id} authenticated={this.props.authenticated} />
                                {item.tags.length > 0
                                    ? <div className="product-tags">
                                        <h2>ข้อมูลจำเพาะของสินค้า</h2>
                                        <div className="tags">
                                            {this.renderTags(item.tags)}
                                        </div>
                                    </div> : null}
                            </div>
                            <div className="remark mt-1">
                                <small className="color-gray" style={{ lineHeight: "12px", display: "block" }}>{translate('PRODUCT_DISCLAIMER')}</small>
                            </div>
                        </div>
                        {(!_.isEmpty(item.wrapper_additional_content) || !_.isEmpty(item.additional_content)) && <Lazyload height="350px" once placeholder={<LoadingInsideDiv />}><div className="additional-contents" dangerouslySetInnerHTML={{ __html: item.wrapper_additional_content || item.additional_content }}></div></Lazyload>}

                        {_.get(material, 'relate_products.count', 0) > 0 && <div className="relate-products">
                            <div className="header">
                                สินค้าจากแบรนด์เดียวกัน
                            </div>
                            <div className="row products">
                                {_.map(_.get(material, 'relate_products.data', []), (p, index) => {
                                    return (
                                        <div key={"relate_" + index} className="col-6 col-lg-3 col-xl-2">
                                            <ProductCard item={p} />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>}
                    </div>
                    <div id="product-customer-info" className="container-fluid px-0">
                        <div className="row bg-white">
                            <div className="col-12">
                                <div className="container">
                                    <div className="row customer-reviews">
                                        <div className="col-12 col-md-6">
                                            <div><h2>รีวิวจากผู้ใช้จริง</h2></div>
                                            <div>
                                                <span className="rating mr-3">
                                                    {item.rating !== 0
                                                        ? <FontAwesomeIcon icon={["fas", "star"]} style={{ color: "#DB1F35" }} />
                                                        : <FontAwesomeIcon icon={["fal", "star"]} style={{ color: "#ccc" }} />
                                                    }
                                                    <span className="ml-2">{item.rating}</span>
                                                </span>
                                                <span>|</span>
                                                <a href="#reviews-section"><span className="review-count mx-3">{item.comments && item.comments.data ? item.comments.data.length : 0} Reviews</span></a>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6 write-review">
                                            <div>
                                                <button type="button" className="btn btn-primary d-flex justify-content-between w-100 btn-write-review" disabled={commentWithoutOrder.length !== 0} onClick={this.onHandleProductComment}><span>เขียนรีวิวสินค้า</span><FontAwesomeIcon icon={faPencil} /></button>
                                            </div>
                                            <div>
                                                ได้รับ BEAUTRIUM Coins สำหรับ Quality Review
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row bg-white product-photos-comments">
                            <div className="col-12">
                                <div className="container">
                                    <div className="row product-photos">
                                        <div className="col-12 d-flex justify-content-between align-items-center">
                                            <h2>คลังภาพจากลูกค้า</h2>
                                            <span className="view-more" onClick={() => this.setState({ visible: true })}>ดูทั้งหมด</span>
                                        </div>
                                        <div className="col-12">
                                            <div className="photos row">
                                                {_.get(item, 'photos.length', false) ? this.renderPhotoReview(item.photos) : <div className="col-12 text-center">ยังไม่มีรูปภาพที่เกี่ยวข้องกับสินค้านี้ค่ะ หากลูกค้าได้ใช้ผลิตภัณฑ์นี้แล้วอย่าลืมโพสต์รูปให้พวกเราดูบ้างนะคะ</div>}
                                            </div>
                                            <AllPhoto visible={this.state.visible} setVisible={(visible) => this.showAllPhoto(visible)} comment={item.comments && item.comments.data ? item.comments.data : []} />
                                            {this.state.showImage &&
                                                <div style={{ width: "100vw", height: "100vh", background: "rgba(0, 0, 0, 0.8)", position: "fixed", zIndex: "1060", padding: "5%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", top: "0", left: "0" }} onClick={(e) => { this.setState({ showImage: false }); e.stopPropagation(); }}>
                                                    <img alt={`${item.brand_en} ${item.mat_name} - ${this.state.firstname}`} src={this.state.imageUrl} className="zoominImage" onClick={() => this.setState({ showImage: false })} />
                                                    <div className="comment mt-4 zoomIn-comment">
                                                        <div style={{ fontWeight: "bold", margin: "0" }} className="row">
                                                            {this.state.firstname} {this.state.lastname}
                                                        </div><br />
                                                        <div className="row" style={{ margin: "0", whiteSpace: "pre-wrap" }}>
                                                            {this.state.comment}
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="row product-comments">
                                        <div className="col-12 d-flex justify-content-between align-items-center">
                                            <h2>ความคิดเห็นจากลูกค้า</h2>
                                        </div>
                                        <div className="col-12 comments">
                                            {this.renderComments(item.comments && item.comments.data ? item.comments.data : [])}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-cmd d-flex d-xl-none">
                        <div className="add-to-cart-btn h-100 row no-gutters mx-0">
                            <button className="btn btn-white col-3 d-flex flex-column align-items-center justify-content-center" onClick={() => { submitChat("product", productToChat) }} type="button"><FontAwesomeIcon icon={["fal", "comments"]} /><span>สอบถาม</span></button>
                            <button className={`btn btn-white col-3  d-flex flex-column align-items-center justify-content-center btn-wishlist ${item.wishlisted === 1 ? "wishlisted" : ""}`} onClick={() => { this.wishlistToggle(item.mat_var_id, item.wishlisted) }} type="button"><FontAwesomeIcon icon={["fal", "heart"]} /><FontAwesomeIcon icon={["fas", "heart"]} /><span className="color-black">{item.wishlisted !== 1 ? "เพิ่ม" : "ลบ"}รายการโปรด</span></button>
                            {isFree
                                ? <button className="btn btn-primary col-6 d-flex justify-content-center align-items-center" type="button" disabled="true">สินค้าของแถม</button>
                                : <button className="btn btn-primary col-6 d-flex justify-content-center align-items-center" type="button" onClick={() => {
                                    this.addToCart(item)
                                }} disabled={soldOut}><FontAwesomeIcon icon={["fas", "shopping-cart"]} style={{ marginRight: "15px" }} />{!soldOut ? translate('ADD_TO_CART') : translate('SOLD_OUT')}</button>
                            }

                        </div>
                    </div>
                </div>
            </Page >
        );
    }
}

class EditableDetail extends Component {

    render() {
        const { html, index } = this.props //authenticated
        return (
            <div className={`tab-pane fade ${index === 1 ? "show active" : ""}`} id={`nav-1-2-default-hor-left-underline--${index}`} style={{ position: "relative" }} role="tabpanel">
                <div style={{ marginBottom: "1rem", minHeight: "20px" }} dangerouslySetInnerHTML={{ __html: html }}></div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        material: state.materials.material,
        material_err: state.materials.material_err,
        authenticated: state.auth.authenticated,
        addWishlistResult: state.prof.addWishlistResult,
        deleteWishlistResult: state.prof.deleteWishlistResult,
        profile: state.prof.profile,
        postComment: state.materials.postComment,
        postRate: state.materials.postRate,
        deleteResult: state.materials.deleteResult,
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale),
        role_id: state.prof.profile ? state.prof.profile.role_id : null,
    };
}

export default connect(mapStateToProps, { addToCart, getProductPromise, toggleWishlistItem, showAuthenticationPopup, postCommentMaterial, postRateMaterial, getProfile, showAllPhotoPopup, deleteComment, swal, close, submitChat })(frontloadConnect(frontLoad, { onMount: true, onUpdate: false })(ProductDetail));
